import { AxiosError } from "axios";
import customAxios from "config";

export const SaveSquareCard = async (
  renterId: string,
  cardNonce: string
): Promise<any> => {
  try {
    const response = await customAxios.post("/api/square/cards/", {
      renter_id: renterId,
      card_nonce: cardNonce,
    });
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      return {
        error: error.response?.data?.error || "Failed to add Square card.",
      };
    }
    return { error: "An unknown error occurred." };
  }
};

// Helper for headers if needed (optional, since customAxios can handle auth)
const getAuthHeaders = () => ({
  "Content-Type": "application/json",
});

// Get Square Details
export const getSquareDetails = async (): Promise<any> => {
  try {
    const response = await customAxios.get("/api/square/details/", {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      return {
        error: error.response?.data?.error || "Failed to get Square details.",
      };
    }
    return { error: "An unknown error occurred." };
  }
};

// Charge Square Card
export const chargeSquareCard = async (
  bookingId: string,
  paymentMethodId: string,
  paymentAmount?: number,
  depositAmount?: number
): Promise<any> => {
  try {
    let body: any = { booking_id: bookingId, card_id: paymentMethodId };
    if (paymentAmount) {
      body.amount = paymentAmount;
    } else if (depositAmount) {
      body.deposit_amount = depositAmount;
    }
    const response = await customAxios.post("/api/square/charge-card/", body, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      return {
        error: error.response?.data?.error || "Failed to charge Square card.",
      };
    }
    return { error: "An unknown error occurred." };
  }
};
